import { useState } from "react";
import * as S from "./styles.ts";
import AccordionItem, {
  TAccordionItem,
} from "@template/components/Accordion/AccordionItem";
import { IRadioBlobProps } from "@template/components/RadioBlob";

export type AccordionItem = TAccordionItem;

export interface IAccordionProps {
  items: TAccordionItem[];
  selected?: (string | number)[];
  onSelect?: (key: any) => void;
  multi?: boolean;
  radio?: IRadioBlobProps | boolean;
  variant?: "flat" | "light" | "underline";
  showArrow?: boolean;
}

const Accordion = ({
                     items = [],
                     selected,
                     onSelect,
                     multi,
                     radio,
                     variant = "flat",
                     showArrow,
                   }: IAccordionProps) => {
  const [defaultSelected, setDefaultSelected] = useState<(string | number)[]>(
    [],
  );

  const usedSelected = selected || defaultSelected;
  const usedOnSelect = onSelect || setDefaultSelected;

  const handleSelect = (key: string | number) => {
    if (multi) {
      if (usedSelected.includes(key)) {
        usedOnSelect(usedSelected.filter((k) => k !== key));
      } else {
        usedOnSelect([...usedSelected, key]);
      }
    } else {
      if (usedSelected.includes(key)) {
        usedOnSelect([]);
      } else {
        usedOnSelect([key]);
      }
    }
  };

  return (
    <S.AccordionWrapper $variant={variant}>
      <S.AccordionContainer>
        {items.map((item) => (
          <AccordionItem
            item={item}
            key={item.key}
            onClick={() => handleSelect(item.key)}
            selected={usedSelected.includes(item.key)}
            radio={radio}
            showArrow={showArrow}
          />
        ))}
      </S.AccordionContainer>
    </S.AccordionWrapper>
  );
};

export default Accordion;
